import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles()((theme: Theme) => ({
  linksContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    gap: '0.3rem',
    overflow: 'hidden',
    padding: '0.5rem',
  },
  
  linkCard: {
    width: '12rem',
    height: '4rem',
    fontSize: '1rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '100%',
  },

  linkButton: {
    color: theme.palette.primary.contrastText,
  },

  nothingSelected: {
    color: theme.palette.error.main,
  },

  cardContainer: {
    flex: '1 1 calc(25% - 0.3rem)',
    minWidth: '10rem',
    height: '4rem',
    marginTop: '0.5rem',
  },
}));